import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchShiftCodesFulfilled = (state, action) => {
  state.shiftCodeStatus = 'succeeded';
  state.shiftCodes = arrayToObjectCovert(action.payload.data);
  state.shiftCodesOrder = action.payload.data.map(code => code.id);
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalShiftCodes = action.payload.total_shift_code_list_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleAddShiftCodeFulfilled = (state, action) => {
  state.shiftCodeStatus = 'succeeded';
  const shiftCodeId = action.payload.data.id;
  if (!state.shiftCodes[shiftCodeId]) {
    state.shiftCodes[shiftCodeId] = [];
  }
  state.shiftCodes[shiftCodeId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchShiftCodeByIdFulfilled = (state, action) => {
  state.shiftCodeStatus = 'succeeded';
  state.currentShiftCode = action.payload.data;
};

const handleUpdateShiftCodeFulfilled = (state, action) => {
  state.shiftCodeStatus = 'succeeded';
  state.shiftCodes[action.payload.data.id] = action.payload.data;
  state.currentShiftCode = action.payload.data;
  state.message = action.payload.message;
};

const handlePending = (state) => {
  state.shiftCodeStatus = 'loading';
};

const handleRejected = (state, action) => {
  state.shiftCodeStatus = 'failed';
  state.error = action.payload?.message || action.error?.message || 'An unknown error occurred';
};

const handleImportShiftCodeFulfilled = (state, action) => {
  state.shiftCodeStatus = 'succeeded';
  state.message = action.payload.message;
  state.shiftCodeFeedbackData = action.payload.data;
  state.shiftCodeFeedbackHeaders = action.payload.headers;
};

export {
  handleFetchShiftCodesFulfilled,
  handleAddShiftCodeFulfilled,
  handleFetchShiftCodeByIdFulfilled,
  handleUpdateShiftCodeFulfilled,
  handleImportShiftCodeFulfilled,
  handlePending,
  handleRejected
};
